import BannerScroll from "./sc-banner-scroll";

class SyoApp {
    BannerScroll: BannerScroll;

    constructor() {
        this.init()
    }

    init() {
        this.BannerScroll = new BannerScroll();
    }
}
export default SyoApp;